module.exports = __webpack_public_path__ + "media/images/flags/1x1/civ-a7a5c399d59f322a425cd0b02280a5e1.svg";